import { get } from "lodash";

const base = (conflict, hideValues = false) => {
	return {
		sectionName: get(conflict, "field.section", ""),
		fieldName: get(conflict, "field.label", ""),
		oldValue: conflict.oldValue ?? '',
		value: conflict.value ?? '',
		hideValues,
	};
};

const upload = (conflict) => {
	return {
		sectionName: conflict.field?.section,
		fieldName: conflict.field?.label,
		hideValues: true,
	};
};

const classificationCodes = (conflict) => {
	return {
		sectionName: get(conflict, "field.section", ""),
		fieldName: get(conflict, "field.label", ""),
		oldValue: conflict.oldValue ?? '',
		value: conflict.value ?? '',
		hideValues: true,
	};
};

const researchTeam = (conflict) => {
	return {
		sectionName: get(conflict, "field.section", ""),
		fieldName: get(conflict, "field.label", ""),
		oldValue: conflict.oldValue ?? '',
		value: conflict.value ?? '',
		hideValues: true,
	};
};

export const formatConflictMessage = {
	base,
	upload,
	researchTeam,
	classificationCodes,
};
